document.addEventListener('DOMContentLoaded', function() {

    // --- 1. ABRIR MODAL (Delegación para botones dinámicos) ---
    document.addEventListener('click', function(e) {
        // Detectamos si el clic fue en un botón .btnModal o un input .inputAbrirModal
        const target = e.target.closest('.btnModal, .inputAbrirModal');
        
        if (target) {
            const idModal = target.getAttribute('data-modal');
            if (!idModal) return;

            const modal = document.querySelector(`#${idModal}`);
            if (modal) {
                modal.classList.add('modal--show');
                // Si el target es un botón dentro de la tabla, evitamos que abra/cierre el acordeón
                e.stopPropagation(); 
            }
        }
    });

    // También para el evento 'focus' en inputs dinámicos
    document.addEventListener('focusin', function(e) {
        if (e.target.classList.contains('inputAbrirModal')) {
            const idModal = e.target.getAttribute('data-modal');
            const modal = document.querySelector(`#${idModal}`);
            if (modal) modal.classList.add('modal--show');
        }
    });

    // --- 2. CERRAR MODAL (Botón Cerrar) ---
    document.addEventListener('click', function(e) {
        const btnCerrar = e.target.closest('.cerrarModal');
        if (btnCerrar) {
            const idModal = btnCerrar.getAttribute('data-modal');
            const modal = document.querySelector(`#${idModal}`);
            if (modal) {
                cerrarYLimpiarModal(modal);
            }
        }
    });

    // --- 3. CERRAR POR FUERA ---
    document.addEventListener("click", function (e) {
        // Buscamos el modal abierto actualmente
        const modalAbierto = document.querySelector('.modal.modal--show');
        if (!modalAbierto) return;

        const ventanaModal = modalAbierto.querySelector('.ventanaModal');
        
        // Si el clic fue en el fondo oscuro (section.modal) pero NO en la ventana blanca
        if (e.target === modalAbierto && (!ventanaModal || !ventanaModal.contains(e.target))) {
            cerrarYLimpiarModal(modalAbierto);
        }
    });

    // --- 4. SALIR CON ESC ---
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            const modals = document.querySelectorAll(".modal--show");
            if (modals.length === 0) return;
            
            const modalToClose = modals[modals.length - 1];
            cerrarYLimpiarModal(modalToClose);
        }
    });

    // Función auxiliar para no repetir código de limpieza
    function cerrarYLimpiarModal(modal) {
        modal.querySelectorAll("form").forEach(form => form.reset());
        modal.classList.remove('modal--show');
    }

});


document.addEventListener('input', (e) => {
    // 1. Detectamos si el cambio fue en el input de horaInicio
    if (e.target.name === 'horaInicio') {
        const inputInicio = e.target;
        const formulario = inputInicio.closest('form');
        
        // Buscamos el input de horaFin dentro del mismo formulario o contenedor
        const inputFin = formulario.querySelector('input[name="horaFin"]');

        if (!inputInicio.value || !inputFin) return;

        // 2. Procesamos la hora
        let [horas, minutos] = inputInicio.value.split(':').map(Number);

        let horasFin = horas + 1;
        let minutosFin = minutos;

        if (horasFin >= 24) {
            horasFin = 0;
        }

        // 4. Formateamos de vuelta a HH:mm (asegurando los ceros a la izquierda)
        const horaFormateada = `${String(horasFin).padStart(2, '0')}:${String(minutosFin).padStart(2, '0')}`;
        
        inputFin.value = horaFormateada;
    }
});



//Gestión de cálculos de entrega con flujo de datos unidireccional.


document.addEventListener('input', (e) => {
    const contenedor = e.target.closest('#canvaEntrega');
    if (!contenedor || e.target.tagName !== 'INPUT') return;

    const toInt = n => {
        const res = parseInt(String(n).replace(/\D/g, ''), 10);
        return isNaN(res) ? 0 : res;
    };
    const format = n => n.toLocaleString('en-US');

    const undEmpaqueCanasta = toInt(contenedor.getAttribute('data-unidad-empaque-canasta')) || 456;
    const undEmpaqueBolsaTula = toInt(contenedor.getAttribute('data-unidad-empaque-bolsa')) || 504;

    const producidoTotal = toInt(contenedor.querySelector('#producidoTotal').textContent);
    const numCanastas   = toInt(contenedor.querySelector('#canastas').value);
    const numBolsas     = toInt(contenedor.querySelector('#bolsas').value);
    const retenido      = toInt(contenedor.querySelector('#retenido').value);
    const rechazado     = toInt(contenedor.querySelector('#rechazado').value);

    const undsCanastas = numCanastas * undEmpaqueCanasta;
    const undsBolsas   = numBolsas * undEmpaqueBolsaTula;
    
    // El entregado total es la suma de todo lo procesado
    const totalEntregado = undsCanastas + undsBolsas + retenido + rechazado;
    const totalPendiente = producidoTotal - totalEntregado;

    // 5. Actualización masiva de la Interfaz (DOM)
    contenedor.querySelector('#canastasUnd').textContent = `${format(undsCanastas)} und`;
    contenedor.querySelector('#bolsasUnd').textContent   = `${format(undsBolsas)} und`;
    contenedor.querySelector('#entregadoTotal').textContent = `${format(totalEntregado)} und`;
    
    const elPendiente = contenedor.querySelector('#pendienteTotal');
    elPendiente.textContent = `${format(totalPendiente)} und`;

    // 6. Lógica visual: Verde si está en 0 o menos
    if (totalPendiente === 0) {
        elPendiente.style.color = '#28a745'; // Verde éxito
        elPendiente.style.fontWeight = 'bold';
    } else {
        elPendiente.style.color = '#ff0000'; // Reset al color por defecto (ej. rojo o gris)
        elPendiente.style.fontWeight = 'bold';
    }
});

document.addEventListener('change', function (e) {
    const inputEstado = e.target.closest('#estado');
    
    if (!inputEstado) return;

    const label = inputEstado.closest('.switchEstado');
    
    if (!label) return;

    const texto = label.querySelector('.textoEstado');
    if (!texto) return;

    if (inputEstado.checked) {
        inputEstado.value = "1";
        texto.textContent = "ACTIVO";
    } else {
        inputEstado.value = "0";
        texto.textContent = "INACTIVO";
    }
});
